// extracted by mini-css-extract-plugin
export default {"subjectCard":"subjectcard_subjectCard__REwRv","cardImage":"subjectcard_cardImage__o4Lt9","cardFooter":"subjectcard_cardFooter__etrvl"};